import { format } from 'date-fns';

import simpleDiffToDate from './simpleDiffToDate';

export default function simpleDiffToFormattedDate(dateDiff: string, dateFormat: string) {
  const asDate = simpleDiffToDate(dateDiff);
  return format(asDate, dateFormat);
}
